import React from 'react';

// A string or number child becomes a DOM text node of its own as soon as it has siblings (anti-pattern #17).
export const rendersAsTextNode = (
  node: React.ReactNode,
): node is string | number =>
  typeof node === 'string' || typeof node === 'number';
